import { render, staticRenderFns } from "./EventWidnows.vue?vue&type=template&id=781430c8&scoped=true&"
import script from "./EventWidnows.vue?vue&type=script&lang=js&"
export * from "./EventWidnows.vue?vue&type=script&lang=js&"
import style0 from "./EventWidnows.vue?vue&type=style&index=0&id=781430c8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781430c8",
  null
  
)

export default component.exports